module.exports = __webpack_public_path__ + "media/images/icon__settings-ae88a8fbc46ed92c5f648dafef854ae9.png";